import CryptoJS from "crypto-js";

const baseURL = process.env.REACT_APP_SERVER_URL;
const CLIENT_ENCRYPTION_KEY =
  process.env.REACT_APP_CLIENT_ENCRYPTION_KEY || "client-default-key-change-in-production";

const getCsrfToken = async () => {
  const result = await fetch(`${baseURL}/api/auth/csrf`, {
    method: "GET",
    credentials: "include",
  });
  return result.json();
};

const hashPassword = (password: string, email: string): string => {
  // Utiliser email comme salt pour unicité
  return CryptoJS.SHA256(password + email + CLIENT_ENCRYPTION_KEY).toString();
};

export const signInService = {
  login: async (data: any) => {
    try {
      const csrfToken = await getCsrfToken();

      // Chiffrer les données sensibles
      const encryptedPassword = CryptoJS.AES.encrypt(data.password, CLIENT_ENCRYPTION_KEY).toString();
      const timestamp = Date.now();
      const nonce = Math.random().toString(36).substring(2, 15);

      const requestData = {
        email: data.email,
        credentials: encryptedPassword,
        timestamp: timestamp,
        nonce: nonce,
        _secure: true,
      };

      const result = await fetch(`${baseURL}/api/auth/login`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": csrfToken?.csrfToken ?? "",
        },
        body: JSON.stringify(requestData),
      });

      const jsonResult = await result.json();

      // Si le serveur ne supporte pas le format chiffré, faire un fallback
      if (jsonResult.error && jsonResult.error.includes("_secure")) {
        // Get a new CSRF token for the fallback request
        const newCsrfToken = await getCsrfToken();

        // Chiffrer le mot de passe pour le fallback aussi
        const fallbackData = {
          email: data.email,
          password: CryptoJS.AES.encrypt(data.password, CLIENT_ENCRYPTION_KEY).toString(),
        };

        const fallbackResult = await fetch(`${baseURL}/api/auth/login`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": newCsrfToken?.csrfToken ?? "",
          },
          body: JSON.stringify(fallbackData),
        });

        return fallbackResult.json();
      }

      return jsonResult;
    } catch (error) {
      console.error("Login API error:", error);
      throw error;
    }
  },
};
